import React from 'react';
import '../App.css';

export default function Copyright_Footer() {
	return (
		<div className="mt-5 p-1 position-static">
			<div className="mx-auto p-1">
				<p className="lightGrey text-center">Copyright © 2023 TeamLewis . All Rights Reserved</p>
			</div>
		</div>
	);
}
